import { Chip } from "@mui/material";
import React from "react";
import { statusSeverity } from "../utils/statusColors";

const StatusBadge = ({ domain, status, disabled = false }) => {
    if (!status) return null;
    return (
        <Chip
            color={statusSeverity(domain, status)}
            size="small"
            variant="outlined"
            label={status}
            disabled={disabled}
        />
    );
};

export default StatusBadge;
